import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import {
  useGetIptvReportsQuery,
  useLazyGetIptvReportsQuery
} from '../../redux/apis/linkManagement/iptv/reports/lmIptvReportsApiSlice'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateIptvReport from '../../components/IPTV/EditCreateIptvReport'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import { can } from '../../helpers/auth'
import IptvAppDropdown from '../../components/IptvAppDropdown'

const IptvTechnicalReports = React.memo(() => {
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)
  const { data, isLoading, error, isFetching } = useGetIptvReportsQuery({
    expand: ['last_updated_by', 'iptv'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'SUBJECT',
      dataIndex: 'subject',
      key: 'subject',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'APP NAME',
      dataIndex: 'iptv',
      key: 'iptv.app_name',
      filter: true,
      filterComponent: IptvAppDropdown,
      render: (text, record) => <div>{text?.app_name}</div>
    },

    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => (
        <div className=''>
          {text.first_name} {text.last_name}
        </div>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          {can('change_iptvtechnicalreports') && (
            <>
              <button
                className='btn btn-outline-theme mb-1 me-1'
                onClick={() => handleEdit(record)}
              >
                Edit
              </button>
              {record?.attachment && (
                <a
                  href={record?.attachment}
                  target="_blank"
                  rel="noopener noreferrer"
                  className='btn btn-warning mb-1 me-1'
                >
                  Download
                </a>
              )}
            </>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {can('add_iptvtechnicalreports') && create ? (
        <EditCreateIptvReport
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      ) : null}
      {can('change_iptvtechnicalreports') && edit ? (
        <EditCreateIptvReport
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      ) : null}
      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />

        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetIptvReportsQuery}
            fileName='iptv-tech-report'
          />
          {can('add_iptvtechnicalreports') && (
            <button
              className='btn btn-outline-theme mb-4'
              onClick={() => setCreate(true)}
            >
              Create New Report
            </button>
          )}
        </div>
      </div>
      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default IptvTechnicalReports
